import { render, staticRenderFns } from "./CargoCrudRotogram.vue?vue&type=template&id=27099cb3"
import script from "./CargoCrudRotogram.vue?vue&type=script&lang=js"
export * from "./CargoCrudRotogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports